// libs
import React, { memo } from 'react';

// hooks
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

// styles
import { Container, SelectedIcon, OutOfStock, SelectedOverlay } from './styles';

// components
import Image from 'shared/components/ImageV2';

// defs
import { IColorOption } from 'shared/components/ColorSwatchesPDP/types';
import { ROLES } from 'shared/constants';

interface ColorItemProps {
  item: IColorOption;
  index: number;
  onItemClick: (colorOption: IColorOption) => void;
  brandLaunchingSoon?: boolean;
}

const OUT_OF_STOCK_TEXT = 'Sold Out';
const IMAGE_WIDTH = '84';

function ColorItem({ item, onItemClick, brandLaunchingSoon }: ColorItemProps) {
  const getAltText = () => {
    const colorName = item.name || 'Color';
    const stockStatus = item.inStock === false && !brandLaunchingSoon ? ', Sold out' : '';
    const selectedStatus = item.isSelected ? ', Currently selected' : '';
    return `${colorName} color option${stockStatus}${selectedStatus}`;
  };

  const getAriaLabel = () => {
    const colorName = item.name || 'Color';
    if (item.inStock === false && !brandLaunchingSoon) {
      return `${colorName} color, Sold out`;
    }
    if (item.isSelected) {
      return `${colorName} color, Currently selected`;
    }
    return `Select ${colorName} color`;
  };

  const keyboardProps = useKeyboardClick(() => onItemClick(item), {
    role: ROLES.LINK,
  });

  return (
    <Container
      className={'color-item'}
      {...keyboardProps}
      isSelected={item.isSelected}
      data-test="color-item"
      aria-label={getAriaLabel()}
      aria-pressed={item.isSelected}
    >
      <Image
        src={item.imageUrl}
        alt={getAltText()}
        aspectRatio={item.aspectRatio}
        // @ts-ignore width should be string
        width={IMAGE_WIDTH}
        lazy={true}
        data-at="color-shade-image"
      />

      {item.isSelected && (
        <>
          <SelectedOverlay />
          <SelectedIcon />
        </>
      )}

      {item.inStock === false && !brandLaunchingSoon && (
        <OutOfStock>{OUT_OF_STOCK_TEXT}</OutOfStock>
      )}
    </Container>
  );
}

export default memo(ColorItem);
